import { FC, Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/style/style.css';
import AppLoader from './components/AppLoader';
import i18n from './i18n/i18nInit';
import Header from './pages/Navbar';
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from './utils/routes';
import ConfirmationModal from './components/ConfirmationModal';
import { t } from 'i18next';
import { useApp } from './useApp';

export const App: FC = () => {
    const {
        showFreeTrialWarningModal,
        daysLeft,
        showPaymentLink,
        handleShowFreeTrialWarningModal,
        isAuthenticated,
        isProtectedRoute,
        isPrivateRoute,
    } = useApp();

    return (
        <Suspense fallback={<AppLoader loadingPosition="center" />}>
            <ToastContainer />
            <I18nextProvider i18n={i18n}>
                <div className="h-100">
                    {isPrivateRoute && <Header />}
                    <div className={`${isPrivateRoute && 'routes-container'}`}>
                        <Routes>
                            {isAuthenticated
                                ? PRIVATE_ROUTES.map((privateRoute, index) => (
                                      <Route
                                          key={index}
                                          path={privateRoute.path}
                                          element={
                                              isProtectedRoute(
                                                  privateRoute.roles,
                                              ) ? (
                                                  <privateRoute.component />
                                              ) : (
                                                  <Navigate to="/" />
                                              )
                                          }
                                      />
                                  ))
                                : PUBLIC_ROUTES.map((publicRoute, index) => (
                                      <Route
                                          key={index}
                                          path={publicRoute.path}
                                          element={<publicRoute.component />}
                                      />
                                  ))}
                        </Routes>
                    </div>

                    {daysLeft === '0' && (
                        <ConfirmationModal
                            showModal={showFreeTrialWarningModal}
                            confirmationModalHandler={
                                handleShowFreeTrialWarningModal
                            }
                            confirmationTitle={''}
                            confirmationMessage={t(
                                'Dashboard:trialExpiredMessage',
                            )}
                            confirmationOptionOnCancel={
                                showPaymentLink
                                    ? t('Dashboard:updatePaymentMethod')
                                    : ''
                            }
                            isDisabled={false}
                        />
                    )}
                </div>
            </I18nextProvider>
        </Suspense>
    );
};
